export interface WorkPreparationRoleId {__workPreparationId: number}

export default class WorkPreparationRole {
  id!: WorkPreparationRoleId;
  description = '';
}